// Buddy: poznámky, návrhy a spotřeba AI (docs/SPEC.md 2.9 a část 6).
import {
  API_PREFIX,
  APP_VERSION_HEADER,
  type AiNoteDetail,
  type AiNoteResponse,
  type AiProposalsResponse,
  type ApproveProposalInput,
  type AiUsageResponse,
  type CreateAiNoteInput,
  type ProposalDecisionResponse,
  type RejectProposalInput,
  type VoiceNoteResponse,
} from '@wac-buddy/shared'
import { api, BASE, errorFromResponse } from './client'

export function postAiNote(input: CreateAiNoteInput): Promise<AiNoteResponse> {
  return api('/ai/notes', { method: 'POST', body: JSON.stringify(input) })
}

export type AiProposalsFilter = 'proposed' | 'approved' | 'auto' | 'rejected' | 'undone' | 'all'

export function getAiProposals(
  status: AiProposalsFilter = 'proposed',
): Promise<AiProposalsResponse> {
  return api(`/ai/proposals?status=${status}`)
}

/** Schválí návrh. S `input` (po „Upravit“) se místo payloadu návrhu použije vstup z formuláře. */
export function approveProposal(
  id: string,
  input?: ApproveProposalInput['input'],
): Promise<ProposalDecisionResponse> {
  const body: ApproveProposalInput = input ? { input } : {}
  return api(`/ai/proposals/${encodeURIComponent(id)}/approve`, {
    method: 'POST',
    body: JSON.stringify(body),
  })
}

export function rejectProposal(id: string, reason?: string): Promise<ProposalDecisionResponse> {
  const body: RejectProposalInput = reason?.trim() ? { reason: reason.trim() } : {}
  return api(`/ai/proposals/${encodeURIComponent(id)}/reject`, {
    method: 'POST',
    body: JSON.stringify(body),
  })
}

/** Vrátí schválený nebo automaticky provedený návrh zpět (do 24 hodin). */
export function undoProposal(id: string): Promise<ProposalDecisionResponse> {
  return api(`/ai/proposals/${encodeURIComponent(id)}/undo`, { method: 'POST' })
}

export function getAiUsage(): Promise<AiUsageResponse> {
  return api('/ai/usage')
}

/**
 * Nahraje hlasovku (multipart: `audio`, `noteId`, `deviceText`, `durationMs`, `clientId`, `jobId`).
 * Bez ručního Content-Type: boundary doplní prohlížeč. Chyba nese `status` (outbox podle něj rozhoduje).
 */
export async function postVoiceNote(form: FormData): Promise<VoiceNoteResponse> {
  const res = await fetch(`${BASE}${API_PREFIX}/ai/voice-notes`, {
    method: 'POST',
    body: form,
    credentials: 'include',
    headers: { [APP_VERSION_HEADER]: __APP_VERSION__ },
  })
  if (!res.ok) throw await errorFromResponse(res)
  return (await res.json()) as VoiceNoteResponse
}

/** Stav zpracování poznámky nebo hlasovky, přepis a návrhy z ní. */
export function getAiNote(id: string): Promise<AiNoteDetail> {
  return api(`/ai/notes/${encodeURIComponent(id)}`)
}
